import { render, staticRenderFns } from "./peopleSide.vue?vue&type=template&id=200f3322&scoped=true&"
import script from "./peopleSide.vue?vue&type=script&lang=js&"
export * from "./peopleSide.vue?vue&type=script&lang=js&"
import style0 from "./peopleSide.vue?vue&type=style&index=0&id=200f3322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f3322",
  null
  
)

export default component.exports